










































import { Component, Vue, Prop } from "vue-property-decorator";
// @ts-ignore
import VueGallerySlideshow from "vue-gallery-slideshow";

@Component({
    components: {
        //@ts-ignore
        VueGallerySlideshow
    }
})
export default class ViewAllImages extends Vue {
    @Prop() images!: Image[];

    $refs!: Vue["$refs"] & {
        imageSlider: HTMLElement;
    };

    index: any = null;

    openIndex(idx: number) {
        this.index = idx;
    }
}
